/*
 * SPDX-FileCopyrightText: © 2025 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

:host {
  display: block;
}

:host(:focus-visible) {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
  border-radius: var(--qds-focus-rounded-border-radius);
}

.qds-mini-button {
  display: flex;
  width: var(--qds-control-mini-button-standard-size);
  min-height: var(--qds-control-mini-button-standard-size);
  align-items: center;
  border-radius: var(--qds-control-rounded-border-radius);
  border: none;
  justify-content: center;
  color: var(--qds-theme-control-text-standard);
  background-color: transparent;
  padding: 0;

  &:hover {
    background-color: var(--qds-theme-interactive-background-hover);
  }

  &:active {
    background-color: var(--qds-theme-interactive-background-pressed);
  }

  &:focus-visible {
    outline: none;
  }
}

.qds-mini-button:disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.qds-icon {
  font-size: var(--qds-control-standard-icon-size);
  align-content: center;
  line-height: normal;
  cursor: pointer;
}
